import { StateObservable } from 'redux-observable';
import { VariablesEditorDialogAction, State, createOpenWithCreate } from '..';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../dependencies.interface';

export const fillNewDataFromApi = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.create$.pipe(map(createOpenWithCreate));
